var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeclosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.707 41.707a1 1 0 0 1-1.414-1.414l6.866-6.866a28.665 28.665 0 0 1-2.303-1.947 34.851 34.851 0 0 1-4.353-4.945c-.163-.226-.276-.39-.337-.484a1 1 0 0 1 0-1.102c.061-.093.174-.258.337-.484a34.851 34.851 0 0 1 4.353-4.945C17.53 16.082 21.452 14 25.5 14c2.62 0 5.186.872 7.667 2.419l7.126-7.126a1 1 0 1 1 1.414 1.414l-6.866 6.866a28.624 28.624 0 0 1 2.302 1.947 34.842 34.842 0 0 1 4.354 4.945c.163.226.276.39.337.484a1 1 0 0 1 0 1.102c-.061.093-.174.258-.337.484a34.842 34.842 0 0 1-4.354 4.945C33.47 34.918 29.548 37 25.5 37c-2.62 0-5.186-.872-7.667-2.419l-7.126 7.126ZM25.5 35c-2.066 0-4.15-.668-6.209-1.877l3.387-3.386a5 5 0 0 0 7.059-7.059l3.674-3.675a26.074 26.074 0 0 1 2.366 1.977 32.877 32.877 0 0 1 4 4.52 32.877 32.877 0 0 1-4 4.52C32.438 33.144 28.942 35 25.5 35Zm2.617-13.531a5 5 0 0 0-6.648 6.648l-3.88 3.88a26.06 26.06 0 0 1-2.366-1.977 32.876 32.876 0 0 1-4-4.52 32.876 32.876 0 0 1 4-4.52C18.561 17.856 22.057 16 25.5 16c2.065 0 4.15.668 6.208 1.877l-3.591 3.592Zm-1.58 1.58-3.489 3.489a3 3 0 0 1 3.49-3.49Zm-2.441 5.27 4.222-4.223a3 3 0 0 1-4.223 4.223Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeclosed);
export default __webpack_public_path__ + "static/media/eyeclosed.dce104371a4b0dc32f357afcfab686a2.svg";
export { ForwardRef as ReactComponent };